import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { DirectSubscriptionService } from '../services/direct-subscription.service';

@Injectable({
  providedIn: 'root',
})
export class IsOnboardedToDirectGuard  {
  TRIAL_INTERSTITIAL_URL = '/direct/trial';

  constructor(
    private directSubscriptionService: DirectSubscriptionService,
    private router: Router,
    private optimizely: OptimizelyService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // If the user is in the pilot phase 2 group - they need to be onboarded
    return this.directSubscriptionService.subscriptionStatus$.pipe(
      filter((status) => status !== null),
      take(1),
      map((sub) => {
        if (sub.onboarded) {
          return true;
        } else {
          return this.router.parseUrl(this.TRIAL_INTERSTITIAL_URL);
        }
      })
    );
  }
}
